
import { defineComponent, computed, ref, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from '@/components/share/Button/index.vue';
import ButtonStamp from '@/components/share/Button/ButtonStamp.vue';
import Popup from '@/components/share/Modal/index.vue';
import ElectricClock from '@/views/components/stamp/ElectricClock.vue';
import { getFullElementDate, daysOfWeek } from '@/util/composables';
import { useStore } from '@/store';
import useUnitApi from '@/api/composables/useUnit';
import { usePostCheckinTimeKeeping } from '@/api/composables/useCheckInTimeKeeping';
import { usePostCheckinBreakStartTimeKeeping } from '@/api/composables/useTimeKeepingBreakStart';
import { usePostCheckinBreakEndTimeKeeping } from '@/api/composables/useTimeKeepingBreakEnd';
import { usePostCheckinTimeKeepingGoOutStart } from '@/api/composables/useTimeKeepingGoOutStart';
import { usePostCheckinTimeKeepingGoOutEnd } from '@/api/composables/useTimeKeepingGoOutEnd';
import { usePostCheckOutTimeKeeping } from '@/api/composables/useCheckOutTimeKeeping';
import showTimeKeepingCurrentStatus from '@/api/composables/useTimeKeepingCurrentStatus';
import UseStressAddressFrom from '@/api/composables/useStressAddressFrom';
import Dropdown from '@/components/share/Dropdown/Dropdown.vue';
import { watch, watchEffect } from '@vue/runtime-core';
import { UNIT_NAME, getCookie } from '@/util/composables';
import LocationIcon from '@/components/Icons/Location.vue';
import CheckinNext from '@/components/Icons/CheckinNext.vue';
import Department from '@/components/Icons/Department.vue';
import router from '@/router';
import ConstantsRouter from '@/constants/router';
import Calendar from '@/components/share/Calendar/DateInput.vue';
import { useLoginAccountStore } from '@/store/modules/login-account';
import { usePersonalApplySettingStore } from '@/store/modules/personal-setting-apply';
import { useDetailWorkingStyleMaster } from '@/api/composables/useWorkingStyleMaster';
import InputTimeNew from '@/components/share/Input/InputTime.vue';
import moment from 'moment';
export enum StampAction {
  CHECK_IN = 'check_in',
  CHECK_IN_OFFICE = 'check_in_office',
  CHECK_IN_REMOTE = 'check_in_remote',
  CHECK_OUT = 'check_out',
  BREAK_START = 'break_start',
  BREAK_END = 'break_end',
  GO_OUT_START = 'go_out_start',
  GO_OUT_END = 'go_out_end',
}
const iconCheckIn = `<svg width="64" height="61" viewBox="0 0 64 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M33.4947 0.334717C32.579 0.334717 31.8366 1.08093 31.8366 2.00142C31.8366 2.92191 32.579 3.66813 33.4947 3.66813H56.043C58.0575 3.66813 59.6906 5.30976 59.6906 7.33484V52.6688C59.6906 54.6939 58.0575 56.3356 56.043 56.3356H33.4947C32.579 56.3356 31.8366 57.0818 31.8366 58.0023C31.8366 58.9227 32.579 59.669 33.4947 59.669H56.043C59.889 59.669 63.0067 56.5349 63.0067 52.6688V7.33484C63.0067 3.46878 59.889 0.334717 56.043 0.334717H33.4947ZM54.1723 29.8471C54.8199 29.1962 54.8199 28.1409 54.1723 27.49L47.5399 20.8232C46.8923 20.1724 45.8425 20.1724 45.1949 20.8232C44.5474 21.4741 44.5474 22.5294 45.1949 23.1803L48.9969 27.0019L34.4402 27.0019C33.583 27.0019 32.9716 27.7982 32.9716 28.6686C32.9716 29.5391 33.583 30.3353 34.4402 30.3353L48.9967 30.3353L45.1949 34.1568C44.5474 34.8077 44.5474 35.863 45.1949 36.5139C45.8425 37.1648 46.8923 37.1648 47.5399 36.5139L54.1723 29.8471ZM18.7627 9.3432C14.9604 8.76075 11.4084 11.3869 10.829 15.2088C10.426 17.8669 11.567 20.4034 13.5785 21.8977C12.828 22.0302 12.118 22.2664 11.4787 22.5995C10.3847 23.1694 9.43051 24.0693 8.94376 25.2586C8.83224 25.3085 8.72452 25.3717 8.62271 25.4485L3.91189 28.9999C3.27934 29.4767 2.78944 30.1193 2.49579 30.8572L0.119091 36.8297C-0.221012 37.6843 0.192551 38.6543 1.04281 38.9962C1.89307 39.338 2.85806 38.9223 3.19816 38.0677L5.57486 32.0952C5.64262 31.9249 5.75567 31.7766 5.90165 31.6666L8.09254 30.0149L7.01701 37.1093C6.82894 38.3499 7.18411 39.5476 7.90385 40.4584L6.72337 49.951C6.70422 50.105 6.64964 50.2525 6.56397 50.3816L1.6054 57.858C1.09742 58.6239 1.30332 59.6587 2.06528 60.1693C2.82724 60.6799 3.85672 60.4729 4.36469 59.707L9.32327 52.2307C9.69452 51.6709 9.93101 51.032 10.014 50.3644L11.0406 42.1091L15.0278 42.7199L18.5533 49.8076C18.6011 49.9037 18.6332 50.007 18.6483 50.1134L19.9138 59.0185C20.0433 59.9298 20.8832 60.563 21.7897 60.4328C22.6963 60.3026 23.3262 59.4584 23.1967 58.5471L21.9312 49.6419C21.8657 49.1808 21.7266 48.7334 21.5194 48.3168L18.5674 42.382C19.7182 41.7583 20.5741 40.6179 20.7862 39.2186L21.2518 36.1478C21.7488 36.3444 22.2836 36.4489 22.8309 36.4489H30.8412C31.757 36.4489 32.4994 35.7027 32.4994 34.7822C32.4994 33.8617 31.757 33.1155 30.8412 33.1155H22.8309C22.5287 33.1155 22.2428 32.9774 22.054 32.7402L21.8141 32.4387L22.4238 28.4169C22.6841 26.7 21.9436 25.1435 20.8267 24.0314C20.4467 23.6531 20.0136 23.3141 19.5385 23.0208C22.1165 22.3159 24.1698 20.1438 24.5982 17.3181C25.1776 13.4961 22.565 9.92566 18.7627 9.3432ZM18.3168 33.3805L14.955 29.1566C14.383 28.4378 14.4989 27.389 15.214 26.814C15.9291 26.2389 16.9725 26.3555 17.5446 27.0743L18.9963 28.8983L19.1454 27.9147C19.2069 27.5093 19.0622 26.9665 18.493 26.3997C17.9239 25.8331 17.0106 25.3451 15.8715 25.1706C14.7324 24.9961 13.7159 25.1885 13.0047 25.559C12.2934 25.9296 11.9944 26.4045 11.933 26.8099L10.2954 37.6115C10.2126 38.1575 10.5859 38.6676 11.129 38.7508L16.3745 39.5543C16.9176 39.6375 17.4251 39.2624 17.5078 38.7164L18.3168 33.3805ZM14.1074 15.711C14.4109 13.7091 16.2715 12.3335 18.2631 12.6386C20.2548 12.9437 21.6233 14.8139 21.3198 16.8159C21.0163 18.8178 19.1557 20.1934 17.164 19.8883C15.1724 19.5832 13.8039 17.713 14.1074 15.711Z" fill="white"/>
</svg>`;
const iconBreakStart = `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.3327 3.33333C25.3327 2.59695 25.9296 2 26.666 2C27.4024 2 27.9993 2.59695 27.9993 3.33333V16.6667C27.9993 17.403 27.4024 18 26.666 18C25.9296 18 25.3327 17.403 25.3327 16.6667V3.33333ZM10.6667 23.3331H42.6667V33.9998C42.6667 42.8363 35.5032 49.9998 26.6667 49.9998C17.8301 49.9998 10.6667 42.8363 10.6667 33.9998V23.3331ZM8 23.3331C8 21.8603 9.19391 20.6664 10.6667 20.6664H42.6667C43.6538 20.6664 44.5157 21.2028 44.9767 22H46.6667C51.0849 22 54.6667 25.5817 54.6667 30C54.6667 34.4183 51.0849 38 46.6667 38H44.9037C43.0725 46.387 35.6029 52.6664 26.6667 52.6664C16.3574 52.6664 8 44.3091 8 33.9998V23.3331ZM45.2864 35.3333H46.6667C49.6122 35.3333 52 32.9455 52 30C52 27.0545 49.6122 24.6667 46.6667 24.6667H45.3333V33.9998C45.3333 34.4482 45.3175 34.8929 45.2864 35.3333ZM9.33333 55.3336C8.59695 55.3336 8 55.9305 8 56.6669C8 57.4033 8.59695 58.0002 9.33333 58.0002H44C44.7364 58.0002 45.3333 57.4033 45.3333 56.6669C45.3333 55.9305 44.7364 55.3336 44 55.3336H9.33333ZM33.334 4.66642C34.0704 4.66642 34.6673 5.26338 34.6673 5.99976V13.9998C34.6673 14.7361 34.0704 15.3331 33.334 15.3331C32.5976 15.3331 32.0007 14.7361 32.0007 13.9998V5.99976C32.0007 5.26338 32.5976 4.66642 33.334 4.66642ZM21.3327 7.33333C21.3327 6.59695 20.7357 6 19.9993 6C19.263 6 18.666 6.59695 18.666 7.33333V12.6667C18.666 13.403 19.263 14 19.9993 14C20.7357 14 21.3327 13.403 21.3327 12.6667V7.33333Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M43.3333 22.6664V33.9998C43.3333 43.2045 35.8714 50.6664 26.6667 50.6664C17.4619 50.6664 10 43.2045 10 33.9998V22.6664H43.3333ZM44.5921 22.6667L44.3996 22.3338C44.0528 21.7341 43.4062 21.3331 42.6667 21.3331H10.6667C9.5621 21.3331 8.66667 22.2285 8.66667 23.3331V33.9998C8.66667 43.9409 16.7255 51.9998 26.6667 51.9998C35.2829 51.9998 42.4866 45.9451 44.2524 37.8578L44.3669 37.3333H46.6667C50.7168 37.3333 54 34.0501 54 30C54 25.9499 50.7168 22.6667 46.6667 22.6667H44.5921ZM44.571 36L44.6214 35.2864C44.6514 34.8615 44.6667 34.4325 44.6667 33.9998V24H46.6667C49.9804 24 52.6667 26.6863 52.6667 30C52.6667 33.3137 49.9804 36 46.6667 36H44.571ZM26.666 2.66667C26.2978 2.66667 25.9993 2.96514 25.9993 3.33333V16.6667C25.9993 17.0349 26.2978 17.3333 26.666 17.3333C27.0342 17.3333 27.3327 17.0349 27.3327 16.6667V3.33333C27.3327 2.96514 27.0342 2.66667 26.666 2.66667ZM10.6667 23.3331H42.6667V33.9998C42.6667 42.8363 35.5032 49.9998 26.6667 49.9998C17.8301 49.9998 10.6667 42.8363 10.6667 33.9998V23.3331ZM44.9767 22C44.5157 21.2028 43.6538 20.6664 42.6667 20.6664H10.6667C9.19391 20.6664 8 21.8603 8 23.3331V33.9998C8 44.3091 16.3574 52.6664 26.6667 52.6664C35.6029 52.6664 43.0725 46.387 44.9037 38H46.6667C51.0849 38 54.6667 34.4183 54.6667 30C54.6667 25.5817 51.0849 22 46.6667 22H44.9767ZM45.3216 34.6667C45.3294 34.4453 45.3333 34.223 45.3333 33.9998V24.6667H46.6667C49.6122 24.6667 52 27.0545 52 30C52 32.9455 49.6122 35.3333 46.6667 35.3333H45.2864C45.302 35.1122 45.3138 34.8899 45.3216 34.6667ZM9.33333 56.0002C8.96514 56.0002 8.66667 56.2987 8.66667 56.6669C8.66667 57.0351 8.96514 57.3336 9.33333 57.3336H44C44.3682 57.3336 44.6667 57.0351 44.6667 56.6669C44.6667 56.2987 44.3682 56.0002 44 56.0002H9.33333ZM34.0007 5.99976C34.0007 5.63157 33.7022 5.33309 33.334 5.33309C32.9658 5.33309 32.6673 5.63157 32.6673 5.99976V13.9998C32.6673 14.3679 32.9658 14.6664 33.334 14.6664C33.7022 14.6664 34.0007 14.3679 34.0007 13.9998V5.99976ZM20.666 7.33333C20.666 6.96514 20.3675 6.66667 19.9993 6.66667C19.6312 6.66667 19.3327 6.96514 19.3327 7.33333V12.6667C19.3327 13.0349 19.6312 13.3333 19.9993 13.3333C20.3675 13.3333 20.666 13.0349 20.666 12.6667V7.33333ZM26.666 2C25.9296 2 25.3327 2.59695 25.3327 3.33333V16.6667C25.3327 17.403 25.9296 18 26.666 18C27.4024 18 27.9993 17.403 27.9993 16.6667V3.33333C27.9993 2.59695 27.4024 2 26.666 2ZM8 56.6669C8 55.9305 8.59695 55.3336 9.33333 55.3336H44C44.7364 55.3336 45.3333 55.9305 45.3333 56.6669C45.3333 57.4033 44.7364 58.0002 44 58.0002H9.33333C8.59695 58.0002 8 57.4033 8 56.6669ZM34.6673 5.99976C34.6673 5.26338 34.0704 4.66642 33.334 4.66642C32.5976 4.66642 32.0007 5.26338 32.0007 5.99976V13.9998C32.0007 14.7361 32.5976 15.3331 33.334 15.3331C34.0704 15.3331 34.6673 14.7361 34.6673 13.9998V5.99976ZM19.9993 6C20.7357 6 21.3327 6.59695 21.3327 7.33333V12.6667C21.3327 13.403 20.7357 14 19.9993 14C19.263 14 18.666 13.403 18.666 12.6667V7.33333C18.666 6.59695 19.263 6 19.9993 6Z" fill="white"/>
</svg>
`;
const iconGoOutStart = `<svg width="64" height="61" viewBox="0 0 64 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M33.4948 0.334473C32.5791 0.334473 31.8368 1.08069 31.8368 2.00118C31.8368 2.92167 32.5791 3.66788 33.4948 3.66788H56.0431C58.0576 3.66788 59.6907 5.30952 59.6907 7.33459V52.6686C59.6907 54.6937 58.0576 56.3353 56.0431 56.3353H33.4948C32.5791 56.3353 31.8368 57.0815 31.8368 58.002C31.8368 58.9225 32.5791 59.6687 33.4948 59.6687H56.0431C59.8891 59.6687 63.0068 56.5347 63.0068 52.6686V7.33459C63.0068 3.46854 59.8891 0.334473 56.0431 0.334473H33.4948ZM54.1725 29.8469C54.82 29.196 54.82 28.1407 54.1725 27.4898L47.54 20.823C46.8925 20.1721 45.8426 20.1721 45.195 20.823C44.5475 21.4739 44.5475 22.5292 45.195 23.1801L48.997 27.0017L34.4403 27.0017C33.5831 27.0017 32.9717 27.7979 32.9717 28.6684C32.9717 29.5388 33.5831 30.3351 34.4403 30.3351L48.9968 30.3351L45.195 34.1565C44.5475 34.8074 44.5475 35.8627 45.195 36.5136C45.8426 37.1645 46.8925 37.1645 47.54 36.5136L54.1725 29.8469ZM18.7628 9.34296C14.9606 8.7605 11.4085 11.3866 10.8291 15.2086C10.4261 17.8667 11.5672 20.4032 13.5786 21.8974C12.8281 22.03 12.1181 22.2662 11.4788 22.5992C10.3848 23.1692 9.43063 24.0691 8.94389 25.2583C8.83237 25.3083 8.72464 25.3715 8.62283 25.4482L3.91201 28.9996C3.27946 29.4765 2.78956 30.119 2.49591 30.857L0.119213 36.8294C-0.22089 37.6841 0.192673 38.6541 1.04293 38.9959C1.8932 39.3378 2.85818 38.9221 3.19828 38.0674L5.57498 32.095C5.64275 31.9247 5.75579 31.7764 5.90177 31.6664L8.09267 30.0147L7.01713 37.1091C6.82906 38.3496 7.18423 39.5474 7.90397 40.4581L6.7235 49.9507C6.70434 50.1048 6.64977 50.2522 6.56409 50.3814L1.60552 57.8577C1.09755 58.6236 1.30344 59.6584 2.0654 60.169C2.82736 60.6796 3.85684 60.4727 4.36481 59.7068L9.32339 52.2304C9.69464 51.6707 9.93113 51.0317 10.0141 50.3642L11.0408 42.1089L15.0279 42.7197L18.5534 49.8073C18.6012 49.9035 18.6333 50.0067 18.6484 50.1131L19.9139 59.0183C20.0434 59.9296 20.8833 60.5627 21.7899 60.4326C22.6964 60.3024 23.3263 59.4581 23.1968 58.5469L21.9313 49.6417C21.8658 49.1806 21.7267 48.7331 21.5195 48.3165L18.5675 42.3817C19.7184 41.7581 20.5742 40.6177 20.7864 39.2184L21.2519 36.1475C21.7489 36.3442 22.2837 36.4487 22.831 36.4487H30.8414C31.7571 36.4487 32.4995 35.7025 32.4995 34.782C32.4995 33.8615 31.7571 33.1153 30.8414 33.1153H22.831C22.5288 33.1153 22.2429 32.9772 22.0541 32.7399L21.8142 32.4385L22.4239 28.4167C22.6842 26.6998 21.9438 25.1432 20.8268 24.0312C20.4468 23.6529 20.0137 23.3139 19.5386 23.0205C22.1166 22.3156 24.1699 20.1435 24.5983 17.3178C25.1777 13.4959 22.5651 9.92542 18.7628 9.34296ZM18.3169 33.3803L14.9552 29.1564C14.3831 28.4376 14.499 27.3887 15.2141 26.8137C15.9292 26.2387 16.9726 26.3552 17.5447 27.074L18.9964 28.898L19.1455 27.9145C19.207 27.5091 19.0624 26.9662 18.4931 26.3995C17.924 25.8329 17.0107 25.3448 15.8716 25.1703C14.7325 24.9958 13.716 25.1883 13.0048 25.5588C12.2935 25.9293 11.9946 26.4042 11.9331 26.8096L10.2955 37.6113C10.2128 38.1573 10.586 38.6673 11.1292 38.7506L16.3746 39.5541C16.9177 39.6373 17.4252 39.2621 17.5079 38.7161L18.3169 33.3803ZM14.1075 15.7108C14.411 13.7088 16.2716 12.3332 18.2632 12.6383C20.2549 12.9434 21.6234 14.8137 21.3199 16.8156C21.0164 18.8176 19.1558 20.1931 17.1642 19.8881C15.1725 19.583 13.804 17.7127 14.1075 15.7108Z" fill="white"/>
</svg>`;
const iconBreakEnd = `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M27.9993 7.66675C27.0789 7.66675 26.3327 8.41294 26.3327 9.33341C26.3327 10.2539 27.0789 11.0001 27.9993 11.0001H49.3327C51.3577 11.0001 52.9994 12.6417 52.9994 14.6667V49.3334C52.9994 51.3585 51.3577 53.0001 49.3327 53.0001H27.9993C27.0789 53.0001 26.3327 53.7463 26.3327 54.6667C26.3327 55.5872 27.0789 56.3334 27.9993 56.3334H49.3327C53.1987 56.3334 56.3327 53.1994 56.3327 49.3334V14.6667C56.3327 10.8008 53.1987 7.66675 49.3327 7.66675H27.9993ZM21.1779 18.8216C20.527 18.1707 19.4717 18.1707 18.8208 18.8216L8.15417 29.4882C7.5033 30.1391 7.5033 31.1944 8.15417 31.8453L18.8208 42.5119C19.4717 43.1628 20.527 43.1628 21.1779 42.5119C21.8287 41.8611 21.8287 40.8058 21.1779 40.1549L13.3564 32.3334H41.3327C42.2532 32.3334 42.9994 31.5872 42.9994 30.6667C42.9994 29.7463 42.2532 29.0001 41.3327 29.0001H13.3564L21.1779 21.1786C21.8287 20.5277 21.8287 19.4724 21.1779 18.8216Z" fill="white"/>
</svg>
`;
const iconGoOutEnd = `<svg width="64" height="61" viewBox="0 0 64 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M33.4946 0.334717C32.5789 0.334717 31.8366 1.08093 31.8366 2.00142C31.8366 2.92191 32.5789 3.66813 33.4946 3.66813H56.0429C58.0575 3.66813 59.6906 5.30976 59.6906 7.33484V52.6688C59.6906 54.6939 58.0575 56.3356 56.0429 56.3356H33.4946C32.5789 56.3356 31.8366 57.0818 31.8366 58.0023C31.8366 58.9227 32.5789 59.669 33.4946 59.669H56.0429C59.8889 59.669 63.0067 56.5349 63.0067 52.6688V7.33484C63.0067 3.46878 59.8889 0.334717 56.0429 0.334717H33.4946ZM33.4572 29.8471C32.8097 29.1962 32.8097 28.1409 33.4572 27.49L40.0897 20.8232C40.7372 20.1724 41.7871 20.1724 42.4346 20.8232C43.0822 21.4741 43.0822 22.5294 42.4346 23.1803L38.6327 27.0019L53.1894 27.0019C54.0466 27.0019 54.658 27.7982 54.658 28.6686C54.658 29.5391 54.0466 30.3353 53.1894 30.3353L38.6328 30.3353L42.4346 34.1568C43.0822 34.8077 43.0822 35.863 42.4346 36.5139C41.7871 37.1648 40.7372 37.1648 40.0897 36.5139L33.4572 29.8471ZM13.7366 9.3432C17.5389 8.76075 21.0909 11.3869 21.6704 15.2088C22.0733 17.8669 20.9323 20.4034 18.9209 21.8977C19.6714 22.0302 20.3815 22.2664 21.0208 22.5995C22.1148 23.1694 23.069 24.0694 23.5558 25.2587C23.6672 25.3086 23.7749 25.3718 23.8767 25.4485L28.5875 28.9999C29.22 29.4767 29.7099 30.1193 30.0036 30.8572L32.3803 36.8297C32.7204 37.6843 32.3068 38.6543 31.4565 38.9962C30.6063 39.338 29.6413 38.9223 29.3012 38.0677L26.9245 32.0952C26.8567 31.9249 26.7437 31.7766 26.5977 31.6666L24.407 30.015L25.4825 37.1093C25.6706 38.3499 25.3153 39.5477 24.5955 40.4585L25.776 49.951C25.7951 50.105 25.8497 50.2525 25.9354 50.3816L30.894 57.858C31.4019 58.6239 31.196 59.6587 30.4341 60.1693C29.6721 60.6799 28.6426 60.4729 28.1347 59.707L23.1761 52.2307C22.8048 51.6709 22.5684 51.032 22.4853 50.3644L21.4587 42.1092L17.4717 42.7199L13.9462 49.8076C13.8984 49.9037 13.8663 50.007 13.8512 50.1134L12.5856 59.0185C12.4561 59.9298 11.6163 60.563 10.7097 60.4328C9.80317 60.3026 9.17325 59.4584 9.30275 58.5471L10.5683 49.6419C10.6338 49.1808 10.7729 48.7334 10.9801 48.3168L13.9321 42.3819C12.7812 41.7583 11.9254 40.6179 11.7133 39.2186L11.2477 36.1477C10.7507 36.3444 10.2158 36.4489 9.6685 36.4489H1.65813C0.742374 36.4489 3.8147e-06 35.7027 3.8147e-06 34.7822C3.8147e-06 33.8617 0.742374 33.1155 1.65813 33.1155H9.6685C9.97072 33.1155 10.2566 32.9774 10.4454 32.7402L10.6854 32.4386L10.0757 28.4169C9.81539 26.7 10.5558 25.1435 11.6728 24.0314C12.0528 23.6531 12.4858 23.3141 12.961 23.0208C10.3829 22.3159 8.32953 20.1438 7.90113 17.3181C7.32171 13.4961 9.93435 9.92566 13.7366 9.3432ZM13.5032 28.8981L13.3541 27.9147C13.2926 27.5093 13.4373 26.9665 14.0065 26.3997C14.5756 25.8331 15.4889 25.3451 16.628 25.1706C17.7671 24.9961 18.7836 25.1885 19.4948 25.559C20.2061 25.9296 20.505 26.4045 20.5665 26.8099L22.2041 37.6115C22.2868 38.1575 21.9136 38.6676 21.3704 38.7508L16.125 39.5543C15.5819 39.6375 15.0744 39.2624 14.9917 38.7164L14.1827 33.3804L17.5443 29.1566C18.1164 28.4378 18.0005 27.389 17.2854 26.814C16.5703 26.2389 15.5269 26.3555 14.9548 27.0743L13.5032 28.8981ZM18.392 15.711C18.0884 13.7091 16.2279 12.3335 14.2362 12.6386C12.2445 12.9437 10.876 14.8139 11.1795 16.8159C11.483 18.8178 13.3436 20.1934 15.3353 19.8883C17.3269 19.5832 18.6955 17.713 18.392 15.711Z" fill="white"/>
</svg>
`;
const iconCheckOut = `<svg width="64" height="61" viewBox="0 0 64 61" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M33.4946 0.334717C32.5789 0.334717 31.8366 1.08093 31.8366 2.00142C31.8366 2.92191 32.5789 3.66813 33.4946 3.66813H56.0429C58.0575 3.66813 59.6906 5.30976 59.6906 7.33484V52.6688C59.6906 54.6939 58.0575 56.3356 56.0429 56.3356H33.4946C32.5789 56.3356 31.8366 57.0818 31.8366 58.0023C31.8366 58.9227 32.5789 59.669 33.4946 59.669H56.0429C59.8889 59.669 63.0067 56.5349 63.0067 52.6688V7.33484C63.0067 3.46878 59.8889 0.334717 56.0429 0.334717H33.4946ZM33.4572 29.8471C32.8097 29.1962 32.8097 28.1409 33.4572 27.49L40.0897 20.8232C40.7372 20.1724 41.7871 20.1724 42.4346 20.8232C43.0822 21.4741 43.0822 22.5294 42.4346 23.1803L38.6327 27.0019L53.1894 27.0019C54.0466 27.0019 54.658 27.7982 54.658 28.6686C54.658 29.5391 54.0466 30.3353 53.1894 30.3353L38.6328 30.3353L42.4346 34.1568C43.0822 34.8077 43.0822 35.863 42.4346 36.5139C41.7871 37.1648 40.7372 37.1648 40.0897 36.5139L33.4572 29.8471ZM13.7366 9.3432C17.5389 8.76075 21.0909 11.3869 21.6704 15.2088C22.0733 17.8669 20.9323 20.4034 18.9209 21.8977C19.6714 22.0302 20.3815 22.2664 21.0208 22.5995C22.1148 23.1694 23.069 24.0694 23.5558 25.2587C23.6672 25.3086 23.7749 25.3718 23.8767 25.4485L28.5875 28.9999C29.22 29.4767 29.7099 30.1193 30.0036 30.8572L32.3803 36.8297C32.7204 37.6843 32.3068 38.6543 31.4565 38.9962C30.6063 39.338 29.6413 38.9223 29.3012 38.0677L26.9245 32.0952C26.8567 31.9249 26.7437 31.7766 26.5977 31.6666L24.407 30.015L25.4825 37.1093C25.6706 38.3499 25.3153 39.5477 24.5955 40.4585L25.776 49.951C25.7951 50.105 25.8497 50.2525 25.9354 50.3816L30.894 57.858C31.4019 58.6239 31.196 59.6587 30.4341 60.1693C29.6721 60.6799 28.6426 60.4729 28.1347 59.707L23.1761 52.2307C22.8048 51.6709 22.5684 51.032 22.4853 50.3644L21.4587 42.1092L17.4717 42.7199L13.9462 49.8076C13.8984 49.9037 13.8663 50.007 13.8512 50.1134L12.5856 59.0185C12.4561 59.9298 11.6163 60.563 10.7097 60.4328C9.80317 60.3026 9.17325 59.4584 9.30275 58.5471L10.5683 49.6419C10.6338 49.1808 10.7729 48.7334 10.9801 48.3168L13.9321 42.3819C12.7812 41.7583 11.9254 40.6179 11.7133 39.2186L11.2477 36.1477C10.7507 36.3444 10.2158 36.4489 9.6685 36.4489H1.65813C0.742374 36.4489 3.8147e-06 35.7027 3.8147e-06 34.7822C3.8147e-06 33.8617 0.742374 33.1155 1.65813 33.1155H9.6685C9.97072 33.1155 10.2566 32.9774 10.4454 32.7402L10.6854 32.4386L10.0757 28.4169C9.81539 26.7 10.5558 25.1435 11.6728 24.0314C12.0528 23.6531 12.4858 23.3141 12.961 23.0208C10.3829 22.3159 8.32953 20.1438 7.90113 17.3181C7.32171 13.4961 9.93435 9.92566 13.7366 9.3432ZM13.5032 28.8981L13.3541 27.9147C13.2926 27.5093 13.4373 26.9665 14.0065 26.3997C14.5756 25.8331 15.4889 25.3451 16.628 25.1706C17.7671 24.9961 18.7836 25.1885 19.4948 25.559C20.2061 25.9296 20.505 26.4045 20.5665 26.8099L22.2041 37.6115C22.2868 38.1575 21.9136 38.6676 21.3704 38.7508L16.125 39.5543C15.5819 39.6375 15.0744 39.2624 14.9917 38.7164L14.1827 33.3804L17.5443 29.1566C18.1164 28.4378 18.0005 27.389 17.2854 26.814C16.5703 26.2389 15.5269 26.3555 14.9548 27.0743L13.5032 28.8981ZM18.392 15.711C18.0884 13.7091 16.2279 12.3335 14.2362 12.6386C12.2445 12.9437 10.876 14.8139 11.1795 16.8159C11.483 18.8178 13.3436 20.1934 15.3353 19.8883C17.3269 19.5832 18.6955 17.713 18.392 15.711Z" fill="white"/>
</svg>
`;
export type AddressComponentType = {
  long_name: string;
  short_name: string;
  types: string[];
};
export default defineComponent({
  components: {
    CheckinNext,
    LocationIcon,
    ElectricClock,
    Button,
    ButtonStamp,
    Popup,
    Dropdown,
    Department,
    Calendar,
    InputTimeNew,
  },
  setup() {
    const optionUnit = ref();
    const timeKeeper = ref('');
    const i18n = useI18n();
    const accountStore = useLoginAccountStore();
    const personalApplySetting = usePersonalApplySettingStore();
    const {
      workingStyleMasterDetail,
      getDetailData,
    } = useDetailWorkingStyleMaster();
    const t = i18n.t;
    const { year, month, date, day } = getFullElementDate();
    const workDay = `${year}${t('year')}${month}${t('month')}${date}${t(
      'dateStamp'
    )}(${t(`${daysOfWeek[`${day}`]}`)})`;
    const store = useStore();
    const profile = computed(() => {
      return accountStore.state.myAccount;
    });
    const textTimeCheckin = ref({
      unit_name: '',
    });
    const checkIn = computed(() => store.state.auth.profile.checkInTime);
    const checkOut = computed(() => store.state.auth.profile.checkOutTime);
    const breakStart = computed(() => store.state.auth.profile.breakStartTime);
    const breakEnd = computed(() => store.state.auth.profile.breakEndTime);
    const checkInEle = computed(() => document.getElementById(`check-in`));
    const checkOutEle = computed(() => document.getElementById(`check-out`));
    const breakStartEle = computed(() =>
      document.getElementById(`break-start`)
    );
    const linkToAllMember = () => {
      const unitId = getCookie('unit_id');
      const date = new Date();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const y = String(date.getFullYear());
      const currentDate = [y, m, d].join('/');
      router.push({
        path: `/new${ConstantsRouter.AllMemberCheckTime}`,
        query: {
          date_check: currentDate,
          unit_ids: [unitId],
        },
      });
    };
    const breakEndEle = computed(() => document.getElementById(`break-end`));
    onBeforeUnmount(() => {
      timeKeeper.value = '';
    });
    const paramsTimeLocal = ref({
      unit_id: '',
      is_remote: false,
      location: '',
    });
    const paramsTimeRemote = ref({
      unit_id: '1',
      is_remote: true,
      location: '',
    });
    // setup for tool
    const dateTool = ref<string>(localStorage.getItem('target_date') || '');
    const timeTool = ref<string>('');

    const buttons = ref([
      {
        label: t('checkIn'),
        icon: {
          src: iconCheckIn,
        },
        isButtonWithIcon: true,
        background: '#007BC3',
        type: StampAction.CHECK_IN,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('stampRegister.checkInOffice'),
        isButtonWithIcon: false,
        background: '#45D1D1',
        type: StampAction.CHECK_IN_OFFICE,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('stampRegister.teleworkCommute'),
        isButtonWithIcon: false,
        background: '#B492FF',
        type: StampAction.CHECK_IN_REMOTE,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('dailyAttendanceHeaders.breakStartTimeRounding'),
        icon: {
          src: iconBreakStart,
        },
        isButtonWithIcon: true,
        background: '#00B172',
        type: StampAction.BREAK_START,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('workingTimeRegister.goOut'),
        icon: {
          src: iconGoOutStart,
        },
        isButtonWithIcon: true,
        background: '#A800C3',
        type: StampAction.GO_OUT_START,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('dailyAttendanceHeaders.breakEndTimeRounding'),
        icon: {
          src: iconBreakEnd,
        },
        isButtonWithIcon: true,
        background: '#F8BF2D',
        type: StampAction.BREAK_END,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('stampRegister.return'),
        icon: {
          src: iconGoOutEnd,
        },
        isButtonWithIcon: true,
        background: '#FF477E',
        type: StampAction.GO_OUT_END,
        isLoading: false,
        isShowButton: false,
      },
      {
        label: t('checkOut'),
        icon: {
          src: iconCheckOut,
        },
        isButtonWithIcon: true,
        background: '#ED5D5D',
        type: StampAction.CHECK_OUT,
        isLoading: false,
        isShowButton: false,
      },
    ]);

    watch(
      () => dateTool.value,
      () => {
        localStorage.setItem('target_value', dateTool.value);
      }
    );
    const isShow = ref(false);
    const showPopupStamp = () => {
      isShow.value = true;
    };
    const hiddenPopupStamp = () => {
      isShow.value = false;
    };
    const headquarters = ref('');
    watchEffect(() => {
      if (!getCookie(UNIT_NAME)) {
        return '';
      } else {
        headquarters.value = getCookie(UNIT_NAME);
      }
    });
    const isAllParams = ref(true);
    const listErrorServerReturn = ref({});
    const { unitList } = useUnitApi({
      is_all: isAllParams.value,
    });
    watchEffect(() => {
      optionUnit.value = unitList.value;
    });
    const paramsTimeCheckin = ref('');
    watchEffect(() => {
      if (!textTimeCheckin.value.unit_name && profile.value) {
        textTimeCheckin.value.unit_name = profile.value.unit_name;
        paramsTimeLocal.value.unit_id = profile.value.unit_id;
      }
      if (paramsTimeCheckin.value) {
        textTimeCheckin.value = optionUnit.value;
      }
    });
    const saveIdUnit = () => {
      textTimeCheckin.value = optionUnit.value.find(
        (item) => item['unit_id'] === paramsTimeLocal.value.unit_id
      );
      hiddenPopupStamp();
    };
    const { address } = UseStressAddressFrom();
    watchEffect(() => {
      if (address && address.value) {
        getRealAddress();
      }
    });
    // get  address
    const getRealAddress = () => {
      let listAddress = [];
      const baseLocal = [
        'country',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'administrative_area_level_3',
        'locality',
        'political',
        'sublocality',
        'sublocality_level_1',
        'sublocality_level_2',
        'sublocality_level_3',
      ];
      const notGetLocal = [
        'administrative_area_level_4',
        'administrative_area_level_5',
        'sublocality_level_4',
        'sublocality_level_5',
        'premise',
        'subpremise',
      ];
      if (address.value.results[0]?.address_components.length) {
        listAddress = address.value.results[0].address_components;
        const addressFirstFilter: AddressComponentType[] = listAddress.filter(
          (item: AddressComponentType) => {
            for (let i = 0; i < item.types.length; i++) {
              if (notGetLocal.includes(item.types[i])) return false;
            }
            return true;
          }
        );
        const addressSecondFilter: AddressComponentType[] = addressFirstFilter.filter(
          (item: AddressComponentType) => {
            for (let i = 0; i < item.types.length; i++) {
              if (baseLocal.includes(item.types[i])) return true;
            }
          }
        );
        let realAddress = '';
        for (let i = addressSecondFilter.length - 1; i >= 0; i--) {
          realAddress += addressSecondFilter[i].long_name;
          if (i === addressSecondFilter.length - 1) {
            realAddress += '、';
          }
        }
        paramsTimeLocal.value.location = realAddress
          ? realAddress
          : address.value.results[0].formatted_address;
        paramsTimeRemote.value.location = realAddress
          ? realAddress
          : address.value.results[0].formatted_address;
      }
    };

    const handleClickCheckTime = async (item) => {
      if (
        item.type === StampAction.CHECK_IN ||
        item.type === StampAction.CHECK_IN_OFFICE
      ) {
        const { postData } = usePostCheckinTimeKeeping({
          ...paramsTimeLocal.value,
          check_in_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.checkInSuccess'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.CHECK_IN_REMOTE) {
        const { postData } = usePostCheckinTimeKeeping({
          ...paramsTimeRemote.value,
          check_in_date: dateTool.value,
          check_in_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.checkInSuccess'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.BREAK_START) {
        const { postData } = usePostCheckinBreakStartTimeKeeping({
          ...paramsTimeLocal.value,
          break_start_date: dateTool.value,
          break_start_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.breakStartSuccess'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.BREAK_END) {
        const { postData } = usePostCheckinBreakEndTimeKeeping({
          ...paramsTimeLocal.value,
          break_end_date: dateTool.value,
          break_end_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.breakEndSuccess'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.GO_OUT_START) {
        const { postData } = usePostCheckinTimeKeepingGoOutStart({
          ...paramsTimeLocal.value,
          go_out_start_date: dateTool.value,
          go_out_start_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.goutStart'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.GO_OUT_END) {
        const { postData } = usePostCheckinTimeKeepingGoOutEnd({
          ...paramsTimeLocal.value,
          go_out_end_date: dateTool.value,
          go_out_end_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.goOutEnd'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
      if (item.type === StampAction.CHECK_OUT) {
        const { postData } = usePostCheckOutTimeKeeping({
          ...paramsTimeLocal.value,
          check_out_date: dateTool.value,
          check_out_time: `${dateTool.value} ${timeTool.value}`,
        });
        postData
          .then(async (error) => {
            if (error) {
              listErrorServerReturn.value = error.errors.value;
              if (error.errorsCommon.value) {
                store.commit('root/SET_NOTIFICATION', {
                  type: 'error',
                  message: error.errorsCommon.value,
                });
              }
            } else {
              store.commit('root/SET_NOTIFICATION', {
                type: 'success',
                message: i18n.t('stampRegister.checkOutSuccess'),
              });
              await getListStatusTimeKeepingCurrent(dateTool.value);
              checkTimeKeeping();
            }
          })
          .catch(() => {
            store.commit('root/SET_NOTIFICATION', {
              type: 'error',
              message: i18n.t('errors.serverError'),
            });
          });
      }
    };

    const changeTime = (value) => {
      const maximumHours =
        workingStyleMasterDetail.value?.maximum_working_hours_per_day;
      const timeCheckin = currentTimeKeeping.value.time_keeping_checkin_time;
      const timeLastCheckIn = moment(timeCheckin, 'YYYY-MM-DD HH:mm:ss').add(
        maximumHours,
        'h'
      );
      const timeNow = moment(value, 'HH:mm:ss');
      checkTimeKeeping(
        currentTimeKeeping.value.time_keeping_current_status,
        timeNow.isBefore(timeLastCheckIn)
      );
    };

    const checkConditionBreak = (
      is_break = workingStyleMasterDetail.value?.is_using_break_time
    ) => {
      let showButtons: string[] = [];
      if (is_break) {
        showButtons = [StampAction.BREAK_START, StampAction.CHECK_OUT];
      } else {
        showButtons = [StampAction.CHECK_OUT];
      }
      return showButtons;
    };
    const checkConditionGoOut = (
      is_go_out = workingStyleMasterDetail.value?.is_using_go_out_check_time
    ) => {
      let showButtons: string[] = [];
      if (is_go_out) {
        showButtons = [StampAction.GO_OUT_START, StampAction.CHECK_OUT];
      } else {
        showButtons = [StampAction.CHECK_OUT];
      }
      return showButtons;
    };
    const checkConditionCheckin = (
      is_remote = workingStyleMasterDetail.value?.is_distinguishing_workplace
    ) => {
      let showButtons: string[] = [];

      if (is_remote) {
        showButtons = [
          StampAction.CHECK_IN_OFFICE,
          StampAction.CHECK_IN_REMOTE,
        ];
      } else {
        showButtons = [StampAction.CHECK_IN];
      }
      return showButtons;
    };
    const checkTimeKeeping = (
      status = currentTimeKeeping.value.time_keeping_current_status,
      is_overtime_checkin = true
    ) => {
      const showButtonGoOut = checkConditionGoOut();
      const showButtonBreak = checkConditionBreak();
      let showButtons: string[] = [...showButtonGoOut, ...showButtonBreak];
      if (!is_overtime_checkin) {
        showButtons = checkConditionCheckin();
      } else
        switch (status) {
          case StampAction.CHECK_IN ||
            StampAction.CHECK_IN_OFFICE ||
            StampAction.CHECK_IN_REMOTE:
            // new flow checkin when overtime checkin
            break;
          case StampAction.GO_OUT_START:
            showButtons = [StampAction.GO_OUT_END];
            break;
          case StampAction.GO_OUT_END:
            break;
          case StampAction.BREAK_START:
            showButtons = [StampAction.BREAK_END];
            break;
          case StampAction.BREAK_END:
            break;
          case StampAction.CHECK_OUT:
            showButtons = checkConditionCheckin();
            break;
          default:
            showButtons = checkConditionCheckin();
            break;
        }

      for (let i = 0; i < buttons.value.length; i++) {
        if (showButtons.includes(buttons.value[i].type)) {
          buttons.value[i].isShowButton = true;
        } else {
          buttons.value[i].isShowButton = false;
        }
      }
    };
    const {
      currentTimeKeeping,
      getListStatusTimeKeepingCurrent,
    } = showTimeKeepingCurrentStatus(dateTool.value);
    watchEffect(async () => {
      if (personalApplySetting.state.data?.working_style_id) {
        await getDetailData(personalApplySetting.state.data?.working_style_id);
        await getListStatusTimeKeepingCurrent(dateTool.value);
        await checkTimeKeeping();
      }
    });
    watchEffect(() => {
      if (currentTimeKeeping.value.time_keeping_current_status) {
        checkTimeKeeping();
      }
    });
    const isDisabled = computed(() => {
      return (
        unitList.value.find((e) => e.unit_id === paramsTimeLocal.value.unit_id)
          ?.unit_name === textTimeCheckin.value.unit_name
      );
    });
    return {
      t,
      checkInEle,
      checkOutEle,
      store,
      buttons,
      workDay,
      profile,
      checkIn,
      checkOut,
      timeKeeper,
      breakStart,
      breakEnd,
      breakStartEle,
      breakEndEle,
      isShow,
      optionUnit,
      paramsTimeLocal,
      paramsTimeRemote,
      unitList,
      listErrorServerReturn,
      currentTimeKeeping,
      address,
      textTimeCheckin,
      headquarters,
      paramsTimeCheckin,
      isAllParams,
      isDisabled,
      //tools
      dateTool,
      timeTool,
      getListStatusTimeKeepingCurrent,
      handleClickCheckTime,
      showTimeKeepingCurrentStatus,
      showPopupStamp,
      hiddenPopupStamp,
      saveIdUnit,
      checkTimeKeeping,
      UseStressAddressFrom,
      getCookie,
      linkToAllMember,
      changeTime,
    };
  },
});
